<template>
        <ul class="rating">
            <li @click="setRating(btn.score)" v-for="btn in btns" :class="btn.status">
            </li>
            <span v-if="userSet">{{userSet}}分</span>
        </ul>

</template>

<script>
    export default {
        name: "ratingSet",
        data(){
            return {
                ratingFull:5,
                userSet:0,
                emptyClass:"emptyFlower",
                fullClass:"full"
            }

        },
        methods:{
            setRating(score){
                this.userSet=score;
                this.$emit("setRating",{score})
            }
        },
        computed:{
            btns(){
                let arr=[];
                for(let i=1;i<=this.ratingFull;i++){
                    let status=this.emptyClass;
                    if(i<=this.userSet){
                        status=this.fullClass;
                    }
                    arr.push({
                        score:i,
                        status
                    })
                }
                return arr;
            }
        }
    }
</script>

<style lang="stylus" scoped>
  @import "~common/stylus/config.styl"
.rating
    display inline-block
    li
        width 20px
        height 20px
        line-height 20px
        font-size 12px
        color #666666
        overflow hidden
        white-space nowrap
        text-overflow ellipsis
        cursor pointer
        user-select none
        display inline-block
        background-position center center
        background-repeat no-repeat
        background-size 70%
        &.emptyFlower
            background-image url(../../assets/images/flower_kong.png)
        &.full
            background-image url(../../assets/images/flower.png)
    &>span
        margin-left 10px
        font-size 14px
        line-height 20px
        vertical-align top
</style>



// WEBPACK FOOTER //
// src/components/globalComp/ratingSet.vue